import React, { useContext } from 'react';

export interface ExperimentsData {
    experiments: string;
}

const experimentsContext = React.createContext<ExperimentsData>({
    experiments: '',
});

export const ExperimentsProvider = experimentsContext.Provider;
export const ExperimentsConsumer = experimentsContext.Consumer;

export function useIsExperimentActivated(name: string, variant: string, version?: string): boolean {
    const { experiments } = useContext(experimentsContext);

    const experimentsArray = experiments.split(';');
    const matchingExperiments = experimentsArray.filter((experimentString) => {
        const parts = experimentString.trim().split(':');
        if (parts.length !== 3) {
            return false;
        }
        return parts[0] === name && parts[1] === variant && (version ? parts[2] === version : true);
    });

    return matchingExperiments.length > 0;
}
